package br.com.vvrefeicoes.portal.core.network

actual val apiBaseUrl: String = "https://portalvv.api.vvrefeicoes.com.br"
